(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7746],{

/***/ 71025:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq",
      function () {
        return __webpack_require__(12829);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* reexport */ Intro; },
  "O": function() { return /* reexport */ IntroBase; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Link/index.ts + 1 modules
var Link = __webpack_require__(504);
// EXTERNAL MODULE: ./modules/sanity/SanityImage.tsx
var SanityImage = __webpack_require__(88114);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Navbar/Navbar.tsx + 6 modules
var Navbar = __webpack_require__(92595);
// EXTERNAL MODULE: ./components/Gradient/index.ts + 1 modules
var Gradient = __webpack_require__(1824);
// EXTERNAL MODULE: ./components/page-sections/Testimonials/index.ts + 1 modules
var Testimonials = __webpack_require__(39021);
// EXTERNAL MODULE: ./components/page-sections/InThePress/index.ts + 5 modules
var InThePress = __webpack_require__(33732);
;// CONCATENATED MODULE: ./components/page-sections/Intro/Intro.tsx








function Intro(param) {
    var title = param.title, text = param.text, _showCallToAction = param.showCallToAction, showCallToAction = _showCallToAction === void 0 ? true : _showCallToAction, _callToActionText = param.callToActionText, callToActionText = _callToActionText === void 0 ? "Get Started" : _callToActionText, _showTestimonials = param.showTestimonials, showTestimonials = _showTestimonials === void 0 ? false : _showTestimonials, _showInThePressLogos = param.showInThePressLogos, showInThePressLogos = _showInThePressLogos === void 0 ? false : _showInThePressLogos, showHeaderMedia = param.showHeaderMedia, image = param.image, youtubeVideoId = param.youtubeVideoId, internalLinkCallToAction = param.internalLinkCallToAction;
    var buildCallToActionUrl = function buildCallToActionUrl(internalLinkCallToAction) {
        if (internalLinkCallToAction) {
            switch(internalLinkCallToAction._type){
                case "questionnaire":
                    return "/questionnaire/".concat(internalLinkCallToAction.slug.current);
                case "page":
                    return "/".concat(internalLinkCallToAction.slug.current);
                case "post":
                    return "/blog/".concat(internalLinkCallToAction.slug.current);
            }
        }
        return "/questionnaire";
    };
    var hasHeaderMedia = showHeaderMedia && showHeaderMedia !== "none" && (image || youtubeVideoId);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroBase, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "py-22 xl:pt-30 xl:pb-30",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center text-white",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("flex justify-between flex-1 max-w-7xl md:px-7 mx-6", {
                            "xl:flex-row xl:items-center": hasHeaderMedia,
                            "flex-col-reverse": hasHeaderMedia && showHeaderMedia === "image",
                            "flex-col": hasHeaderMedia && showHeaderMedia === "youtubeEmbed"
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("w-full", {
                                    "xl:w-7/12 xl:pr-8 xl:mt-0": hasHeaderMedia
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: classnames_default()("xl:text-5.5xl text-5xl leading-12  xl:leading-18 font-semibold text-center xl:text-left", {
                                            "xl:text-center max-w-3xl mx-auto": !hasHeaderMedia
                                        }),
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: classnames_default()("font-inter mt-4 text-base text-center xl:leading-8 xl:text-xl xl:text-left", {
                                            "xl:text-center max-w-1.5xl mx-auto": !hasHeaderMedia,
                                            "xl:max-w-lg": hasHeaderMedia
                                        }),
                                        children: text
                                    }),
                                    showCallToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()("flex justify-center mt-10 xl:justify-start xl:mt-6", {
                                            "xl:justify-center": !hasHeaderMedia
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                            href: buildCallToActionUrl(internalLinkCallToAction),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "flex items-center justify-center flex-1 max-w-md px-8 py-4 text-sm font-medium tracking-widest text-white uppercase rounded-full xl:flex-none bg-gradient-to-tr from-dawnOrange-500 to-dawnPurple-500 xl:py-6 md:text-base",
                                                children: callToActionText
                                            })
                                        })
                                    })
                                ]
                            }),
                            showHeaderMedia === "image" && image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative mb-10 overflow-hidden xl:flex-1 rounded-xl h-80",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* default */.Z, {
                                    image: image,
                                    fill: true,
                                    width: 400
                                })
                            }),
                            showHeaderMedia === "youtubeEmbed" && youtubeVideoId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative xl:pt-[28.5%] pt-[56.2%] w-full xl:w-[60%] overflow-hidden mt-10 xl:mt-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                    className: "absolute inset-0 w-full h-full rounded-xl",
                                    src: "https://www.youtube.com/embed/".concat(youtubeVideoId),
                                    title: "YouTube video player",
                                    frameBorder: "0",
                                    allowFullScreen: true
                                })
                            })
                        ]
                    })
                }),
                showInThePressLogos && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InThePress/* InThePressLogos */.P, {})
                }),
                showTestimonials && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "xl:mt-30 mt-22",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials/* TestimonialCarousel */.N, {})
                })
            ]
        })
    });
}
function IntroBase(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "overflow-hidden bg-dawnDark-700",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.25,
                        left: "-50rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 8,
                        opacity: 0.15,
                        left: "-60rem",
                        top: "10rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.25,
                        right: "-30rem",
                        top: "-20rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 7,
                        opacity: 0.1,
                        right: "-40rem",
                        top: "-2rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
                    children
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/page-sections/Intro/index.ts



/***/ }),

/***/ 41697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ usePreviewSubscription; },
/* harmony export */   "i3": function() { return /* binding */ sanityClient; },
/* harmony export */   "vc": function() { return /* binding */ config; }
/* harmony export */ });
/* unused harmony export useCurrentUser */
/* harmony import */ var next_sanity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81035);

var config = {
    projectId: "4jrvqlog",
    dataset: "production",
    apiVersion: "2021-07-21",
    useCdn: "production" === "production"
};
var usePreviewSubscription = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createPreviewSubscriptionHook */ .KF)(config);
var useCurrentUser = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createCurrentUserHook */ .Iy)(config);
var sanityClient = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createClient */ .eI)(config);


/***/ }),

/***/ 6430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ CategoryQuestionsList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(504);



function CategoryQuestionsList(param) {
    var category = param.category, questions = param.questions, _isCategoryPage = param.isCategoryPage, isCategoryPage = _isCategoryPage === void 0 ? false : _isCategoryPage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("font-semibold", "".concat(isCategoryPage ? "text-2.5xl leading-8 md:text-5xl md:leading-14" : "text-2xl md:text-4xl")),
                children: category.name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-6 space-y-4",
                children: [
                    questions.map(function(question) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Link__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r, {
                            href: "/faq/".concat(question.slug.current),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "block text-base font-inter text-dawnDark-700 hover:text-dawnPurple-500 md:text-xl md:leading-8",
                                children: question.question
                            })
                        }, question._id);
                    }),
                    !isCategoryPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Link__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r, {
                        href: "/faq/category/".concat(category.slug.current),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "block text-base font-inter text-dawnPurple-500 md:text-xl md:leading-8",
                            children: "View all"
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 88114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SanityImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_sanity_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61202);
/* harmony import */ var lib_sanity__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41697);






function SanityImage(param) {
    var image = param.image, className = param.className, _fill = param.fill, fill = _fill === void 0 ? false : _fill, _width = param.width, width = _width === void 0 ? 800 : _width, _sizes = param.sizes, sizes = _sizes === void 0 ? "(max-width: 800px) 100vw, 800px" : _sizes;
    var imageProps = (0,next_sanity_image__WEBPACK_IMPORTED_MODULE_2__/* .useNextSanityImage */ .J)(lib_sanity__WEBPACK_IMPORTED_MODULE_3__/* .sanityClient */ .i3, image, {
        imageBuilder: function(imageUrlBuilder, options) {
            return imageUrlBuilder.width(Math.min(width, options.width));
        }
    });
    return fill ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: imageProps.src,
        alt: image.alt,
        loader: imageProps.loader,
        layout: "fill",
        sizes: sizes,
        objectFit: "cover",
        className: className
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, imageProps), {
        alt: image.alt,
        layout: "responsive",
        sizes: sizes,
        className: className
    }));
};


/***/ }),

/***/ 12829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ FrequentlyAskedQuestions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_page_sections_Intro__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47849);
/* harmony import */ var components_page_sections_CallToAction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31437);
/* harmony import */ var modules_faq_CategoryQuestionsList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6430);





var __N_SSG = true;
function FrequentlyAskedQuestions(param) {
    var frequentlyAskedQuestionsCategorized = param.frequentlyAskedQuestionsCategorized;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Frequently Asked Questions | Dawn Health"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Frequently asked questions we often get about sleep."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "initial-scale=1.0, width=device-width"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: "text-dawnDark-500",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_page_sections_Intro__WEBPACK_IMPORTED_MODULE_2__/* .Intro */ .p, {
                        title: "Frequently Asked Questions",
                        text: "Look through our FAQs to find the most commonly asked questions about Dawn and how we use the science of sleep to get you sleeping better, sooner.",
                        showCallToAction: false
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-center px-6 py-22 md:py-30",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "max-w-[822px] w-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "space-y-10 md:space-y-18",
                                children: frequentlyAskedQuestionsCategorized.map(function(faq) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_faq_CategoryQuestionsList__WEBPACK_IMPORTED_MODULE_4__/* .CategoryQuestionsList */ .B, {
                                        category: faq.category,
                                        questions: faq.questions
                                    }, faq.category._id);
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_page_sections_CallToAction__WEBPACK_IMPORTED_MODULE_3__/* .CallToAction */ .J, {
                        title: "Cure your insomnia today.",
                        text: "Craving good sleep? Talk to a sleep coach and find out more about Dawn\u2019s program for curing sleep problems"
                    })
                ]
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9122,5329,5430,1421,1310,2595,1437,2232,9774,2888,179], function() { return __webpack_exec__(71025); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);